import chunk from 'lodash/chunk';
import React from 'react';
import styled from 'styled-components';
import { StandaloneLink } from '@zocdoc-mezzanine/components-link';

const NUM_COLUMNS = 5;

/**
 * Displays the contents of the Table for the TopListingPagesPopup
 * @param {Array} cities -- Array of cities, with name and url segment
 * @param {Object} specialty  -- Specialty name and url segment
 * @returns {JSX.Element}
 * @constructor
 */
export const TableGrid = ({ cities, specialty }) => (
    <TableGridContainer>
        {chunk(cities, Math.ceil(cities.length / NUM_COLUMNS)).map(
            (cityColumn, idx) => (
                <ul key={`${specialty.name}-col-${idx}`}>
                    {cityColumn.map((city) => (
                        <TableCell key={city.name}>
                            <StandaloneLink
                                data-test={`${specialty.name}-${city.name}`}
                                href={`${specialty.url}${city.url}`}
                                title={`${specialty.name} in ${city.name}`}
                            >
                                {city.name}
                            </StandaloneLink>
                        </TableCell>
                    ))}
                </ul>
            )
        )}
    </TableGridContainer>
);

const TableGridContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`;
const TableCell = styled.li`
    margin-bottom: 16px;
    padding-right: 48px;
`;
